import React, { useState, useEffect, useRef } from 'react';
import ChatInput from './ChatInput';
import ChatMessage from './ChatMessage';

function ChatLayoutMobile({ chatInfo }) {
  const [messages, setMessages] = useState([
    {
      fromUser: false,
      message: `You're now speaking to ${chatInfo.contact} about "${chatInfo.subject}".`,
      time: new Date(),
      reaction: null,
    },
    {
      fromUser: false,
      message: `Hello ${chatInfo.name}, I'm here to listen.`,
      time: new Date(),
      reaction: null,
    },
  ]);

  const chatRef = useRef(null);

  const handleSendMessage = async (text) => {
    const userMsg = {
      fromUser: true,
      message: text,
      time: new Date(),
      reaction: null,
    };
    setMessages((prev) => [...prev, userMsg]);

    try {
      const res = await fetch('https://sausebot.resolvedchallenge.com/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: text,
          name: chatInfo.name,
          subject: chatInfo.subject,
          contact: chatInfo.contact,
        }),
      });

      const data = await res.json();

      const aiMsg = {
        fromUser: false,
        message: data.response || "I'm here to listen.",
        time: new Date(),
        reaction: null,
      };

      setMessages((prev) => [...prev, aiMsg]);
    } catch (err) {
      console.error('❌ Backend error:', err);
      setMessages((prev) => [
        ...prev,
        {
          fromUser: false,
          message: 'Sorry, something went wrong. Please try again.',
          time: new Date(),
          reaction: null,
        },
      ]);
    }
  };

  const handleReaction = (index, emoji) => {
    setMessages((prev) =>
      prev.map((msg, i) => (i === index ? { ...msg, reaction: emoji } : msg))
    );
  };

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <div className="chat-container-mobile">
      <div className="chat-header">📱 MOBILE VIEW</div>
      <div ref={chatRef} className="chat-body">
        {messages.map((msg, idx) => (
          <ChatMessage key={idx} {...msg} onReact={(emoji) => handleReaction(idx, emoji)} />
        ))}
      </div>
      <ChatInput onSend={handleSendMessage} />
    </div>
  );
}

export default ChatLayoutMobile;
